import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import useScope from '../../../Scope/Hooks/useScope';
import WorkplaceProviderCodeModal from './WorkplaceProviderCodeModal';

interface Props {
	workplaceId: string;
}

const WorkplaceProviderCodeButton: React.FC<Props> = ({ workplaceId }) => {
	const [isSettingsOpen, setIsSettingsOpen] = useState(false);
	const { isSlovakia } = useScope();

	if (!isSlovakia) {
		return <></>;
	}

	return (
		<>
			<Button
				title='component.workplaceProviderCode.button'
				theme={Theme.BLUE}
				onClick={() => setIsSettingsOpen(true)}
			/>
			<WorkplaceProviderCodeModal
				isOpen={isSettingsOpen}
				onClose={() => setIsSettingsOpen(false)}
				workplaceId={workplaceId}
			/>
		</>
	);
};

export default WorkplaceProviderCodeButton;
